(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PresentListDeleteController',PresentListDeleteController);

    PresentListDeleteController.$inject = ['$uibModalInstance', 'entity', 'PresentList'];

    function PresentListDeleteController($uibModalInstance, entity, PresentList) {
        var vm = this;
        vm.presentList = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PresentList.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
